// src/store/store.js

import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Reducers
import authReducer from '../features/authSlice';
import cartReducer from '../features/cartSlice';
import wishlistReducer from '../features/wishlistSlice';
import subscriptionReducer from '../features/subscriptionSlice';
import adminAuthReducer from '../features/adminAuthSlice';
import orderReducer from '../features/orderSlice';
import bookReviewReducer from '../features/bookReviewSlice'; // ✅ Import BookReview reducer
import addressReducer from '../features/addressSlice';
import deliveryReducer from '../features/deliverySlice';


const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'adminAuth', 'cart', 'wishlist', 'subscription', 'orders', 'bookReview', 'address', 'delivery'], // ✅ Add 'delivery' to whitelist
};

const rootReducer = combineReducers({
  auth: authReducer,
  adminAuth: adminAuthReducer,
  cart: cartReducer,
  wishlist: wishlistReducer,
  subscription: subscriptionReducer,
  orders: orderReducer,
  bookReview: bookReviewReducer, // ✅ Add BookReview slice to root reducer
  address: addressReducer,
  delivery: deliveryReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
